export default () => {
  const message = document.querySelector('[data-drupal-messages]')

  if (!message) return

  message.addEventListener('click', () => {
    message.remove();
  })
}
